import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { ensureIsAnonymous } from "@/router/guardians"

export const routes = [
  {
    path: "/",
    name: "auth-layout-login",
    component: () => import("@/layouts/auth/AuthLayout.vue"),
    children: [
      {
        path: "/",
        name: "login",
        component: () => import("@/modules/login/pages/Login.vue"),
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.runGuardians(to, from, next, [ensureIsAnonymous])
        }
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () => import("@/modules/login/pages/password-reset/PasswordResetPage.vue"),
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.runGuardians(to, from, next, [ensureIsAnonymous])
        }
      }
    ]
  }
]
